import { render, staticRenderFns } from "./editMenuType.vue?vue&type=template&id=1c1d7ce7&scoped=true&"
import script from "./editMenuType.vue?vue&type=script&lang=js&"
export * from "./editMenuType.vue?vue&type=script&lang=js&"
import style0 from "./editMenuType.vue?vue&type=style&index=0&id=1c1d7ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d7ce7",
  null
  
)

export default component.exports